export const errorStyles = {
  minHeight: "44px",
  borderRadius: "8px",
  background: "#BE0F00",
  width: "max-content",
  top: "40px",
  boxShadow: "0px 6px 10px 0px rgba(30, 39, 59, 0.10)",
  color: "#ffffff",
};

export const confimationStyles = {
  height: "44px",
  borderRadius: "8px",
  background: "#83BF6E",
  top: "40px",
  boxShadow: "0px 6px 10px 0px rgba(30, 39, 59, 0.10)",
  color: "#ffffff",
};

export const warningmoreStyles = {
  height: "68px",
  borderRadius: "8px",
  background: "rgb(255 193 7)",
  top: "40px",
  boxShadow: "0px 6px 10px 0px rgba(30, 39, 59, 0.10)",
  color: "#ffffff",
};

export const warningStyles = {
  height: "44px",
  borderRadius: "8px",
  background: "rgb(255 193 7)",
  top: "40px",
  boxShadow: "0px 6px 10px 0px rgba(30, 39, 59, 0.10)",
  color: "#ffffff",
};
